import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { adminHttp } from "~/Admin/services/http";
import { connect } from "react-redux";
import { toast } from 'react-toastify';

const AdminEditRsvp = ({ invitation, event, onChange, dispatch, ...rest }) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const [status, setStatus] = useState(invitation.rsvp_status);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleStatusChange = (e) => {
        setStatus(e.target.value);
    };

    const handleSubmit = () => {
        toast.promise(
            adminHttp.post('/events/' + event.id + '/invitations/' + invitation.id + '/change-rsvp', { rsvp_status: status }),
            {
                pending: 'Updating RSVP status...',
                success: {
                    render() {
                        setError(null);
                        setShow(false);
                        onChange();
                        return 'RSVP status updated'
                    }
                },
                error: {
                    render(error) {
                        setError(error.data?.response?.data);
                        return 'Something went wrong!'
                    }
                }
            }
        )
    };

    return (
        <>
            <button {...rest} onClick={handleShow}>Change RSVP Status</button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Change RSVP Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <p>Current status: <strong>{invitation.rsvp_status}</strong></p>

                    <p>New status:</p>

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving tickets!"}
                        </div>
                    )}

                    <select defaultValue={status} onChange={e => handleStatusChange(e)} className="form-control">
                        <option value="pending">pending</option>
                        <option value="confirmed">confirmed</option>
                        <option value="declined">declined</option>
                        <option value="ad_hoc">ad hoc</option>
                    </select>

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEditRsvp);
